export default __webpack_public_path__ + "static/media/paper_ru.80048a80.pdf";